<template>
  <router-view />
</template>

<script setup lang="ts">
// import debug from '@/utils/debug';
import { urlTrsJson } from '@/utils/util';
import { useI18n } from 'vue-i18n';
const i18n: any = useI18n();
onMounted(() => {
  const urlArr = location.href.split('?');
  const params: any = urlTrsJson(urlArr[1] || '');
  console.log(params, 'params---');
  if (params?.token) {
    localStorage.setItem('Token', params.token);
  }
  if (params?.LanguageType) {
    i18n.locale.value = params?.LanguageType || 'zh';
    console.log(i18n.locale.value, 'i18n.locale.value---');
    localStorage.setItem('language', i18n.locale.value);
  }
  if (params?.groupId) {
    localStorage.setItem('groupId', params.groupId);
  }
  // 因为debug是存入localStorage中的，刷新页面会从localStorage取出，根据debug控制是否隐藏
  // debug.init();
});
</script>

<style>
#app {
  font-family: Inter, Avenir, Helvetica, Arial, sans-serif;
  font-synthesis: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-text-size-adjust: 100%;
}
</style>
